export * from './cy'
export * from './mixpanel'

export enum TradingLayout {
  Left = 'left',
  Right = 'right'
}

export enum TradeTypes {
  Limit = 'limit',
  Market = 'market'
}

export enum TradeAmountOption {
  Base = 'base',
  Quote = 'quote'
}

export enum OrderbookViewOption {
  Trades = 'trades',
  Orderbook = 'orderbook'
}

export enum ClosePositionLimitFormField {
  Price = 'price',
  Quantity = 'quantity'
}

export enum MarginMode {
  Cross = 'cross',
  Isolated = 'isolated'
}

export enum TradingInterface {
  Standard = 'standard'
}

export enum OrderbookLayout {
  Buys = 'buys',
  Sells = 'sells',
  Default = 'default'
}

export enum TakeProfitStopLossFormField {
  StopLoss = 'stopLoss',
  TakeProfit = 'takeProfit'
}

export enum PredictionsTradeFormField {
  Side = 'side',
  Amount = 'amount'
}

export enum Duration {
  OneHour = '1H',
  SixHour = '6H',
  OneDay = '1D',
  OneWeek = '1W',
  OneMonth = '1M',
  OneYear = '1Y',
  YearToDate = 'YTD',
  All = 'ALL'
}

export enum InvestmentTypeGst {
  Base = 'base',
  Quote = 'quote',
  BaseAndQuote = 'baseAndQuote'
}

export enum TimeDuration {
  Day = 'day',
  Hour = 'hour',
  Minute = 'minute',
  Second = 'second'
}

export enum SubaccountBalanceStreamType {
  TotalBalance = 'total_balances',
  AvailableBalance = 'available_balances'
}

export enum DefaultMarket {
  Perpetual = 'btc-usdc-perp',
  PerpetualTestnet = 'btc-usdc-perp',
  PerpetualDevnet = 'inj-usdc-perp'
}

export enum PortfolioChartType {
  Pnl = 'pnl',
  Volume = 'volume',
  Balance = 'balance',
  TradableBalance = 'tradableBalance'
}

export enum DerivativeTradeTypes {
  Limit = 'limit',
  Market = 'market',
  StopLimit = 'stop-limit',
  StopMarket = 'stop-market'
}

export enum PaginationState {
  InvalidQuery = 'invalid-query',
  QueryPageExist = 'query-page-exist',
  QueryMoreThanTotalPage = 'query-more-than-total-page'
}

export enum TradingChartInterval {
  '1m' = '1',
  '3m' = '3',
  '5m' = '5',
  'D' = '1D',
  'W' = '1W',
  '1h' = '60',
  '15m' = '15',
  '30m' = '30',
  '2h' = '120',
  '4h' = '240',
  '6h' = '360'
}

export enum StopReason {
  User = 'user',
  StopLoss = 'stop_loss',
  Emergency = 'emergency',
  TakeProfit = 'take_profit',
  InsufficientFunds = 'insufficient_funds',
  ExceededMaxRetries = 'exceeded_max_retries'
}

export enum TradeExecutionType {
  Market = 'market',
  LimitFill = 'limitFill',
  StopLimit = 'stopLimit',
  StopMarket = 'stopMarket',
  LimitMatchNewOrder = 'limitMatchNewOrder',
  LimitMatchRestingOrder = 'limitMatchRestingOrder'
}

export enum PerpOrdersStandardView {
  Orders = 'orders',
  Balances = 'balances',
  Positions = 'positions',
  OrderHistory = 'orderHistory',
  TradeHistory = 'tradeHistory',
  FundingHistory = 'fundingHistory'
}

export const MarketCategoryType = {
  All: 'all',
  Favorites: 'favorites',
  Crypto: 'crypto',
  Stocks: 'stocks',
  Macro: 'macro',
  Meme: 'meme',
  Trending: 'trending',
  // === HIDDEN
  Recent: 'recent',
  RWA: 'rwa',
  SEDA: 'seda'
}

export type MarketCategoryType =
  (typeof MarketCategoryType)[keyof typeof MarketCategoryType]

export enum NoticeBanner {
  Stocks = 'stocks',
  StockTwits = 'stock-twits',
  MKRMigration = 'mkr-migration',
  ExpiryFutures = 'expiry-futures',
  DeprecatedWallet = 'deprecated-wallet',
  PerpSettleMarket = 'perp-settle-market',
  PreLaunchFutures = 'pre-launch-futures'
}

export enum DerivativesTradeFormField {
  Type = 'type',
  Side = 'side',
  Amount = 'amount',
  Leverage = 'leverage',
  PostOnly = 'postOnly',
  Slippage = 'slippage',
  StopLoss = 'stopLoss',
  LimitPrice = 'limitPrice',
  ReduceOnly = 'reduceOnly',
  TakeProfit = 'takeProfit',
  AmountOption = 'amountOption',
  TriggerPrice = 'triggerPrice',
  isTpSlEnabled = 'isTpSlEnabled',
  BypassPriceWarning = 'bypassPriceWarning'
}

export enum BusEvents {
  OpenOnramper = 'open-onramper',
  FundingRefresh = 'funding-refresh',
  NavLinkClicked = 'nav-link-clicked',
  WalletConnected = 'wallet-connected',
  PostOnlyToggled = 'post-only-toggled',
  SubaccountChange = 'subaccount-change',
  OrderSideToggled = 'order-side-toggled',
  OrderbookReplaced = 'orderbook-replaced',
  AutoSignConnected = 'auto-sign-connected',
  OrderbookSizeClick = 'orderbook-size-click',
  EvmNetworkMismatch = 'evm-network-mismatch',
  GoToPerpOrdersView = 'go-to-perp-orders-view',
  OrderbookPriceClick = 'orderbook-price-click',
  AddMarginToPosition = 'add-margin-to-position',
  SetPositionStatusIdle = 'set-position-status-idle',
  OrderbookNotionalClick = 'orderbook-notional-click',
  ConnectMobileModalOpened = 'connect-mobile-modal-opened',
  DerivativeStreamLimitTradeExecuted = 'derivative-stream-limit-trade-executed'
}

export enum Modal {
  QrCode = 'qrcode',
  Connect = 'connect',
  Onboard = 'onboard',
  Slippage = 'slippage',
  Leverage = 'leverage',
  Withdraw = 'withdraw',
  Onboarding = 'onboarding',
  MarginMode = 'margin-mode',
  AddGrantee = 'add-grantee',
  SharePoints = 'share-points',
  UserFeedback = 'user-feedback',
  GeoRestricted = 'geo-restricted',
  ConnectMobile = 'connect-mobile',
  ShareTradePnl = 'share-trade-pnl',
  ClosedRwaMarket = 'closed-rwa-market',
  NinjaPassWinner = 'ninja-pass-winner',
  SharePositionPnl = 'share-position-pnl',
  PredictionsEnable = 'predictions-enable',
  ReferralEnterCode = 'enter-referral-code',
  ReferralCreateCode = 'create-referral-code',
  PredictionsCashOut = 'predictions-cash-out',
  PredictionsGeoblock = 'predictions-geoblock',
  PredictionsWithdraw = 'predictions-withdraw',
  PredictionsMoveFunds = 'predictions-move-Funds',
  EstablishConnection = 'establish-connection',
  AddMarginToPosition = 'add-margin-to-position',
  PartialClosePosition = 'partial-close-position',
  AddTakeProfitStopLoss = 'add-take-profit-stop-loss'
}

export enum TcCtaToast {
  StockTwits = 'stock-twits',
  Announcements = 'announcements',
  EnableAutoSign = 'enable-auto-sign',
  ReferralSuccess = 'referral-success',
  UserDoesntTrade = 'user-doesnt-trade',
  UserWithNoAssets = 'user-with-no-assets',
  WalletEmptyWithEvmAssets = 'wallet-empty-with-evm-assets'
}

export enum PartialLimitField {
  PositionPrice = 'positionPrice',
  PositionQuantity = 'positionQuantity'
}

export enum ReferralField {
  ReferralEnterCode = 'referralEnterCode',
  ReferralCreateCode = 'referralCreateCode'
}

export enum PortfolioType {
  Pnl = 'pnl',
  Account = 'account'
}

export enum TCEventType {
  WasmRfqAcceptQuote = 'wasm-rfq-accept-quote'
}

export enum DepositView {
  Select = 'select',
  Crypto = 'crypto',
  Fiat = 'fiat'
}

export enum EvmNetwork {
  // Testnet
  OPSepolia = 'op-sepolia',
  BaseSepolia = 'base-sepolia',
  PolygonAmoy = 'polygon-amoy',
  EthereumSepolia = 'ethereum-sepolia',
  ArbitrumSepolia = 'arbitrum-sepolia',
  // Mainnet
  Base = 'base',
  Polygon = 'polygon',
  Ethereum = 'ethereum',
  Optimism = 'optimism',
  Arbitrum = 'arbitrum',
  // Injective
  InjectiveTestnet = 'InjectiveTestnet',
  Injective = 'Injective'
}

export enum DepositStateName {
  Mint = 'mint',
  Funded = 'funded',
  Completed = 'completed',
  Attestation = 'attestation',
  ApproveBurn = 'approve-burn'
}

export enum PromiseSettledStatus {
  Fulfilled = 'fulfilled',
  Rejected = 'rejected'
}

export enum BridgeType {
  Slow = 'slow',
  Instant = 'instant'
}

export enum BridgeErrorFlow {
  Onboarding = 'onboarding',
  Predictions = 'predictions'
}

export enum BridgeErrorCategory {
  Unknown = 'unknown',
  Disconnected = 'disconnected',
  NetworkChanged = 'network-changed',
  OwnerMismatch = 'owner-mismatch',
  WalletRejection = 'wallet-rejection',
  InsufficientGas = 'insufficient-gas',
  InsufficientBalance = 'insufficient-balance'
}

export const AccessModalStep = {
  AccessControl: 'access-control',
  AutoSignSetup: 'auto-sign-setup',
  AutoSignAuthorization: 'auto-sign-authorization',
  StartTrading: 'start-trading'
} as const

export type AccessModalStep =
  (typeof AccessModalStep)[keyof typeof AccessModalStep]
